// import firebase from '../../config-firebase/firebase'
import { database, databaseShared } from '../../config-firebase/firebase'
import { ref, child, get, set, off, onValue, onChildAdded, limitToLast, onDisconnect, query, orderByKey, endAt, runTransaction, update, push, remove, serverTimestamp } from "firebase/database";
import authentication from './auth'
import store from '../store'
import * as types from '../store/mutations-types'
import EventEmitter from 'events'
import Constants from './constants'
import Config from '../../config-app/config'
import { ErrorAstaNotFound, ErrorSessionExist } from "./errors";
import * as Helpers from './helpers'
import * as Utils from './utils'
import { lte } from 'lodash';

const versionRef = ref(databaseShared, 'version');
const calciatoriRef = ref(databaseShared, 'calciatori')
const listoneConfRef = ref(databaseShared, 'listone-conf')
const userAstaRef = ref(databaseShared, 'user-asta');
const astaBasicRef = ref(databaseShared, 'asta-basic');

let astaRef = ref(database, 'asta');
let astaPassRef = ref(database, 'asta-pass');
let passAstaRef = ref(database, 'pass-asta');
let astasquadreRef = ref(database, 'asta-squadre');
let astaroundRef = ref(database, 'asta-round');
let astaonlineRef = ref(database, 'asta-online');
let astamessagesRef = ref(database, 'asta-messages');
let astaLogsRef = ref(database, 'asta-logs');
let astascartatiRef = ref(database, 'asta-scartati');
let connectedRef = ref(database, '.info/connected');
let calciatoriCustomRef = ref(database, 'asta-calciatori-custom');

// console.log('calciatoriRef', calciatoriRef)
// console.log('astaRef', astaRef)
class Asta extends EventEmitter {

  constructor() {
    super()
  }

  // è un duplicato di quello in mixins
  wait(ms) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, ms);
    })
  }

  generatePassword(prefix, separator = '-', length = 8) {
    const safeChars = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let password = '';

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * safeChars.length);
      password += safeChars[randomIndex];
    }

    return prefix + separator + password;
  }


  // version
  getVersion() {
    return get(versionRef)
      .then((snapshot) => {
        let version = snapshot.val();
        return version
      });
  }

  async createAstaESquadra(astaName, uid, maxSquadre, creditiLega, nP, nD, nC, nA, nomeSquadra, picSquadra, mode, tipoRuoli) {

    // generate new key
    const asta_id = push(astaRef).key;

    // init all needed values
    let astaInfo = {
      name: astaName,
      admin: uid,
      lega: {
        maxSquadre: maxSquadre,
        crediti: creditiLega,
        nRuoli: {
          nP: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? nP : -1,
          nD: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? nD : -1,
          nC: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? nC : -1,
          nA: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? nA : -1,
          op: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? "=" : "illimitati",
        }
      },
      settings: {
        mode: mode,
        tipo_ruoli: tipoRuoli
      }
    }
    astaInfo = this.initAstaInfo(asta_id, astaInfo)

    let astaBasic = this.initAstaBasic()

    // pass x invito (uso asta_id come prefix solo per garantire unicità della pass)
    const pass = this.generatePassword(asta_id);

    try {
      // 1) add to user-aste (è importante che sia al primo posto perchè le db rules di lista-aste si basano su questa)
      await this.addAstaToUser(Config.ANNO_ID, uid, Config.TORNEO_ID, asta_id)

      // 2) add to astaBasic
      await this.addToAstaBasic(Config.TORNEO_ID, Config.ANNO_ID, asta_id, astaBasic)

      // 3) create astaInfo
      await this.createAstaInfo(asta_id, astaInfo)

      // 4) pass
      await this.addAstePass(asta_id, pass)
      await this.addPassAsta(pass, asta_id)

      // 5) create squadra
      await this.createSquadra(asta_id, uid, nomeSquadra, picSquadra, creditiLega)

    } catch (error) {
      throw new Error(error.message)
    }

    return asta_id
  }

  getAstaInfo(asta_id) {
    return get(child(astaRef, asta_id))
      .then((snapshot) => {
        let asta = snapshot.val();
        if (!asta) {
          throw new ErrorAstaNotFound("Asta " + asta_id + " non trovata")
        }
        return asta
      });
  }

  // getAstaInfo(asta_id) {
  //   return get(child(astaRef, asta_id))
  //     .then((snapshot) => {
  //       let asta = snapshot.val();
  //       if (!asta) {
  //         throw new ErrorAstaNotFound("Asta " + asta_id + " non trovata")
  //       }
  //       return this.initAstaInfo(asta_id, asta)
  //     });
  // }

  // getAstaInfo(asta_id) {
  //   return get(child(astaRef, asta_id))
  //     .then((snapshot) => {
  //       return snapshot.val()
  //     });
  // }

  getAstaPass(asta_id) {
    return get(child(astaPassRef, asta_id))
      .then((snapshot) => {
        return snapshot.val() || null;
      });
  }

  getAstaIdByPass(pass) {
    return get(child(passAstaRef, pass))
      .then((snapshot) => {
        return snapshot.val()
      })
  }

  initAstaInfo(asta_id, _astaInfo = {}) {
    let astaInfo = {}
    astaInfo.id = asta_id;
    // astaInfo.name = _astaInfo.name;
    // astaInfo.admin = _astaInfo.admin;
    // astaInfo.counter = _astaInfo.counter || Constants.NUM_ASSEGNAZIONI_FREE;
    // astaInfo.premium = _astaInfo.premium || 0;

    astaInfo.name = (_astaInfo && _astaInfo.name !== undefined) ? _astaInfo.name : '';
    astaInfo.admin = (_astaInfo && _astaInfo.admin !== undefined) ? _astaInfo.admin : Constants.NO_ADMIN;
    astaInfo.counter = (_astaInfo && _astaInfo.counter !== undefined) ? _astaInfo.counter : Constants.NUM_ASSEGNAZIONI_FREE;
    astaInfo.premium = (_astaInfo && _astaInfo.premium !== undefined) ? _astaInfo.premium : 0;
    astaInfo.statoMercato = (_astaInfo && _astaInfo.statoMercato !== undefined) ? _astaInfo.statoMercato : 1;

    // astaInfo.squadra = false;
    astaInfo.settings = {
      // tipo_ruoli: (_astaInfo.settings && _astaInfo.settings.tipo_ruoli) ? _astaInfo.settings.tipo_ruoli : Constants.TIPO_RUOLI.CLASSIC,
      // status: Constants.ASTA_STATUS.NOT_RUNNING,
      // mode: _astaInfo.settings.mode,
      // timeout_c: 30,
      // timeout_s: 30,
      // ch_mode: Constants.CHOOSER_MODE.MANUAL,
      // random_mode: Constants.RANDOM_MODE.DISABLED,
      // ch_list_order: Constants.CHOOSER_LIST_ORDER.QUOTAZIONE,
      // base_asta: Constants.BASE_ASTA.UNO,

      tipo_ruoli: (_astaInfo && _astaInfo.settings && _astaInfo.settings.tipo_ruoli !== undefined) ?
        _astaInfo.settings.tipo_ruoli : Constants.TIPO_RUOLI.CLASSIC,

      status: (_astaInfo && _astaInfo.settings && _astaInfo.settings.status !== undefined) ?
        _astaInfo.settings.status : Constants.ASTA_STATUS.NOT_RUNNING,

      mode: (_astaInfo && _astaInfo.settings && _astaInfo.settings.mode !== undefined) ?
        _astaInfo.settings.mode : Constants.ASTA_MODE.SELVAGGIA,

      timeout_c: (_astaInfo && _astaInfo.settings && _astaInfo.settings.timeout_c !== undefined) ?
        _astaInfo.settings.timeout_c : 30,

      timeout_s: (_astaInfo && _astaInfo.settings && _astaInfo.settings.timeout_s !== undefined) ?
        _astaInfo.settings.timeout_s : 30,

      ch_mode: (_astaInfo && _astaInfo.settings && _astaInfo.settings.ch_mode !== undefined) ?
        _astaInfo.settings.ch_mode : Constants.CHOOSER_MODE.MANUAL,

      random_mode: (_astaInfo && _astaInfo.settings && _astaInfo.settings.random_mode !== undefined) ?
        _astaInfo.settings.random_mode : Constants.RANDOM_MODE.DISABLED,

      base_asta: (_astaInfo && _astaInfo.settings && _astaInfo.settings.base_asta !== undefined) ?
        _astaInfo.settings.base_asta : Constants.BASE_ASTA.UNO,

      ch_list_order: (_astaInfo && _astaInfo.settings && _astaInfo.settings.ch_list_order !== undefined) ?
        _astaInfo.settings.ch_list_order : Constants.CHOOSER_LIST_ORDER.QUOTAZIONE,

      offerta_auto: (_astaInfo && _astaInfo.settings && _astaInfo.settings.offerta_auto !== undefined) ?
        _astaInfo.settings.offerta_auto : Constants.OFFERTA_AUTO.ENABLED,

      ruolo_da_chiamare: (_astaInfo && _astaInfo.settings && _astaInfo.settings.ruolo_da_chiamare !== undefined) ?
        _astaInfo.settings.ruolo_da_chiamare : Constants.RUOLO_DA_CHIAMARE.QUALUNQUE,
    };

    // qui o le passo tutte in _astaInfo.lega o nessuna => nn c'è bisogno di fare i check a uno a uno
    astaInfo.lega = _astaInfo.lega || {
      maxSquadre: 8,
      crediti: 250,
      nRuoli: {
        nP: 3,
        nD: 8,
        nC: 8,
        nA: 6,
        op: '='
      },
      // questi 2 nn ho testato se posso farne a meno di inizializzarli
      usaTuttoBudget: 0,
      limitRosaPerClub: {
        perClubPerRuolo: {
          active: 0,
          valore: ""
        }
      }
    };
    return astaInfo
  }

  initAstaBasic() {
    let astaBasic = {}
    astaBasic.table_num = Config.TABLE_NUM_DEFAULT;
    return astaBasic
  }

  fetchAstaInfo() {
    let id = store.getters.asta_id
    off(child(astaRef, id));
    onValue(child(astaRef, id), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ASTA_UPD, _val)
    });

    off(child(astaRef, id + '/counter'));
    onValue(child(astaRef, id + '/counter'), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ASTA_UPD, {
        counter: _val
      })
      this.emit('counter', _val);
    });

    // astaRef.child(id).child('settings/status').off();
    // astaRef.child(id).child('settings/status').on('value', (snapshot) => {

    off(child(astaRef, id + '/settings/status'));
    onValue(child(astaRef, id + '/settings/status'), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.SETTINGS_UPD, {
        status: _val
      })
      this.emit('status', _val);
    });
  }


  createAstaInfo(asta_id, astaInfo) {
    return set(child(astaRef, asta_id), astaInfo)
  }

  addAstePass(asta_id, pass) {
    return set(child(astaPassRef, asta_id), pass)
  }

  addPassAsta(pass, asta_id) {
    return set(child(passAstaRef, pass), asta_id)
  }

  createSquadra(asta_id, uid, nomeSquadra, picSquadra, crediti) {
    // let asta_info = store.state.asta.info;
    // astasquadreRef.child(asta_info.id).child(uid).set({
    return set(child(astasquadreRef, asta_id + '/' + uid), {
      name: nomeSquadra,
      crediti: crediti,
      pic: picSquadra,
      calciatori: {}
    })
  }

  updateNomeSquadra(asta_id, uid, nome) {
    return update(child(astasquadreRef, asta_id + '/' + uid), {
      name: nome,
    })
  }

  updatePicSquadra(asta_id, uid, pic) {
    return update(child(astasquadreRef, asta_id + '/' + uid), {
      pic: pic,
    })
  }

  updateAdmin(uid) {
    let asta_id = store.getters.asta_id;
    return update(child(astaRef, asta_id), {
      admin: uid,
    })
  }

  // removeSquadra(id) {
  //   let asta_id = store.getters.asta_id;
  //   // astasquadreRef.child(asta_id).child(id).remove()
  //   remove(child(astasquadreRef, asta_id + '/' + id))
  // }

  setOrdineSquadra(id_squadra, order) {
    let asta_id = store.getters.asta_id;
    // return astasquadreRef.child(asta_id).child(id_squadra).child('order').set(order);
    return set(child(astasquadreRef, asta_id + '/' + id_squadra + '/order'), order);
  }

  setActiveSquadra(id_squadra, active) {
    let asta_id = store.getters.asta_id;
    // return astasquadreRef.child(asta_id).child(id_squadra).child('active').set(active);
    return set(child(astasquadreRef, asta_id + '/' + id_squadra + '/active'), active);
  }

  fetchSquadre() {

    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    if (asta_id) {
      off(child(astasquadreRef, asta_id));
      onValue(child(astasquadreRef, asta_id), (snapshot) => {

        // verifico esistenza mia squadra
        let _squadre = snapshot.val() || {};

        // console.log('fetchSquadre', _squadre)

        let sq_exists = false;
        for (let s in _squadre) {
          sq_exists = sq_exists || (s == user_uid)
        }
        store.commit(types.SQUADRE_SET, _squadre)
        store.commit(types.ASTA_UPD, {
          squadra: sq_exists
        })
        // _this.emit('fetchedSquadre');
      });
    }

  }

  fetchMyPlan() {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    if (asta_id && user_uid) {
      off(child(astasquadreRef, asta_id + '/' + user_uid + "/plan"));
      onValue(child(astasquadreRef, asta_id + '/' + user_uid + "/plan"), (snapshot) => {
        let val = snapshot.val();
        store.commit(types.PLAN_SET, val)
      });
    }
  }


  getAstaSquadre(asta_id) {
    return get(child(astasquadreRef, asta_id))
      .then((snapshot) => {
        let squadre = snapshot.val();
        return squadre
      });
  }

  getSquadra(asta_id, squadra_id) {
    return get(child(astasquadreRef, asta_id + '/' + squadra_id))
      .then((snapshot) => {
        return snapshot.val();
      });
  }

  getSquadre() {
    let asta_id = store.getters.asta_id;
    return get(child(astasquadreRef, asta_id))
      .then((snapshot) => {
        // console.log('snapshot.val()', snapshot.val())
        let squadre = snapshot.val();
        // console.log('getSquadre', squadre)
        return squadre
      });
  }

  fetchAstaLogsLast() {
    let asta_id = store.getters.asta_id;
    const lastChildQuery = query(child(astaLogsRef, asta_id), orderByKey(), limitToLast(1));
    onChildAdded(lastChildQuery, (snapshot) => {
      let log = snapshot.val() || {};
      log.key = snapshot.key
      store.commit(types.ASTA_LOGS_LAST, log);
      // eccezione per capire quando è stato assegnato un calciatore 
      if (log.t == Constants.LOG_TYPE.ASSIGN) {
        const assegnazione = {
          squadra_id: log.sid,
          calciatore_id: log.cid,
          prezzo: log.p,
        }
        this.emit("calciatoreAssegnato", assegnazione)
      }
    });
  }

  setAstaLogsAll(nItems, endAtValue) {
    let asta_id = store.getters.asta_id;
    store.commit(types.ASTA_LOGS_LOADING, true)
    if (endAtValue) {
      let queryRef = query(child(astaLogsRef, asta_id), orderByKey(), limitToLast(nItems + 1), endAt(endAtValue));
      // onValue(queryRef, (snapshot) => {
      //   let logs = []
      //   // se nn lo trasformo in array, rischio che vue mi perde l'ordinamento giusto
      //   snapshot.forEach((childSnapshot) => {
      //     let log = childSnapshot.val();
      //     log.key = childSnapshot.key // aggiungo la key tra i valori per facilitarmi dopo
      //     logs.unshift(log) // perchè firebase nn me lo da direttamente in ordine inverso
      //   });
      //   store.commit(types.ASTA_LOGS_ALL, logs)
      //   store.commit(types.ASTA_LOGS_LOADING, false)
      // });

      get(queryRef).then((snapshot) => {
        if (snapshot.exists()) {
          let logs = []
          // se nn lo trasformo in array, rischio che vue mi perde l'ordinamento giusto
          snapshot.forEach((childSnapshot) => {       
            let log = childSnapshot.val();
            log.key = childSnapshot.key // aggiungo la key tra i valori per facilitarmi dopo
            logs.unshift(log) // perchè firebase nn me lo da direttamente in ordine inverso
          });
          store.commit(types.ASTA_LOGS_ALL, logs)
          store.commit(types.ASTA_LOGS_LOADING, false)
        }
      });

    } else {
      let queryRef = query(child(astaLogsRef, asta_id), orderByKey(), limitToLast(nItems + 1));
      // onValue(queryRef, (snapshot) => {
      //   let logs = []
      //   snapshot.forEach((childSnapshot) => {
      //     let log = childSnapshot.val();
      //     log.key = childSnapshot.key
      //     logs.unshift(log)
      //   });
      //   store.commit(types.ASTA_LOGS_ALL, logs)
      //   store.commit(types.ASTA_LOGS_LOADING, false)
      // });

      get(queryRef).then((snapshot) => {
        if (snapshot.exists()) {
          let logs = []
          snapshot.forEach((childSnapshot) => {
            let log = childSnapshot.val();
            log.key = childSnapshot.key
            logs.unshift(log)
          });
          store.commit(types.ASTA_LOGS_ALL, logs)
          store.commit(types.ASTA_LOGS_LOADING, false)
        }
      });
    }

  }

  // calciatori
  getCalciatoriOriginal() {
    return get(child(calciatoriRef, Config.TORNEO_ID + '/' + Config.ANNO_ID))
      .then((snapshot) => {
        let calciatori = snapshot.val();
        // console.log('calciatori', calciatori)
        return calciatori
      });
  }

  getListoneConf() {
    return get(child(listoneConfRef, Config.TORNEO_ID + '/' + Config.ANNO_ID))
      .then((snapshot) => {
        let listoneConf = snapshot.val();
        return listoneConf
      });
  }

  fetchCalciatoriCustom() {
    let asta_id = store.getters.asta_id;
    off(child(calciatoriCustomRef, asta_id));
    onValue(child(calciatoriCustomRef, asta_id), (snapshot) => {
      let calciatoriCustom = snapshot.val() || {};
      store.commit(types.CALCIATORI_CUSTOM, calciatoriCustom);
    });
  }

  setCalciatoreCustom(calciatore_id, ruolo_id) {
    let asta_id = store.getters.asta_id;
    return set(child(calciatoriCustomRef, asta_id + '/' + calciatore_id + '/ID_Ruolo'), ruolo_id.toString());
  }

  removeCalciatoreCustom(calciatore_id) {
    let asta_id = store.getters.asta_id;
    return remove(child(calciatoriCustomRef, asta_id + '/' + calciatore_id));
  }

  assegnaCalciatore(id_calciatore, id_squadra, crediti, i = 0) {
    let asta_id = store.getters.asta_id;
    let asta_squadre = store.getters.asta_squadre;

    if (!id_calciatore) return Promise.reject("Error assegnaCalciatore id_calciatore");
    if (!id_squadra in asta_squadre) return Promise.reject("Error assegnaCalciatore id_squadra");

    let squadra = asta_squadre[id_squadra];

    if (squadra.crediti - parseFloat(crediti) < 0) {
      return Promise.reject("Error crediti insufficienti");
    }

    let updates = {};
    updates['/asta-squadre/' + asta_id + '/' + id_squadra + '/crediti'] = squadra.crediti - parseFloat(crediti);
    updates['/asta-squadre/' + asta_id + '/' + id_squadra + '/calciatori/' + id_calciatore] = {
      p: parseFloat(crediti),
      i: i
    };

    return new Promise(function(resolve, reject) {
      // firebase.database.ref().update(updates).then(function () {
      update(ref(database), updates)
        .then(function() {
          resolve({
            calciatore: id_calciatore,
            squadra: id_squadra,
            crediti: parseFloat(crediti)
          });
        })
    });

    //return astasquadreRef.child(asta_id).child(migliore_offerta.vincitore).child('calciatori').child(id_calciatore).set()
  }

  rimuoviCalciatoreAssegnato(id_calciatore, id_squadra) {
    let asta_id = store.getters.asta_id;
    let asta_squadre = store.getters.asta_squadre;

    if (!id_calciatore) return Promise.reject("Error rimuoviCalciatoreAssegnato id_calciatore");
    if (!id_squadra in asta_squadre) return Promise.reject("Error rimuoviCalciatoreAssegnato id_squadra");

    let squadra = asta_squadre[id_squadra];

    if (!id_calciatore in squadra.calciatori) return Promise.reject("Error");
    let calciatore = squadra.calciatori[id_calciatore];

    let updates = {};
    updates['/asta-squadre/' + asta_id + '/' + id_squadra + '/crediti'] = squadra.crediti + parseFloat(calciatore.p);
    updates['/asta-squadre/' + asta_id + '/' + id_squadra + '/calciatori/' + id_calciatore] = null;

    // return firebase.database.ref().update(updates);
    return update(ref(database), updates);

  }

  modificaCalciatoreAssegnato(id_calciatore, id_squadra, crediti) {
    let asta_id = store.getters.asta_id;
    let asta_squadre = store.getters.asta_squadre;

    if (!id_calciatore) return Promise.reject("Error modificaCalciatoreAssegnato id_calciatore");
    if (!id_squadra in asta_squadre) return Promise.reject("Error modificaCalciatoreAssegnato id_squadra");

    let squadra = asta_squadre[id_squadra];

    if (!id_calciatore in squadra.calciatori) return Promise.reject("Error");
    let calciatore = squadra.calciatori[id_calciatore];

    let updates = {};
    updates['/asta-squadre/' + asta_id + '/' + id_squadra + '/crediti'] = squadra.crediti + parseFloat(calciatore.p) - parseFloat(crediti);
    updates['/asta-squadre/' + asta_id + '/' + id_squadra + '/calciatori/' + id_calciatore] = {
      p: parseFloat(crediti),
      i: 0
    };

    // return firebase.database.ref().update(updates);
    return update(ref(database), updates);
  }

  setCreditiExtra(id_squadra, creditiExtra) {
    let asta_id = store.getters.asta_id;
    return set(child(astasquadreRef, asta_id + '/' + id_squadra + '/crediti_extra'), parseFloat(creditiExtra));
  }

  // setPlanCalciatori(ruolo_abc, slot, calciatori_ids) {
  //   const asta_id = store.getters.asta_id;
  //   const user_uid = authentication.getUserId();
  //   const values = Object.fromEntries(calciatori_ids.entries())
  //   return set(child(astasquadreRef, asta_id + '/' + user_uid + '/plan/' + ruolo_abc + '/' + slot + '/calciatori'), values);
  // }

  // setPlanCrediti(ruolo_abc, slot, crediti) {
  //   let asta_id = store.getters.asta_id;
  //   let user_uid = authentication.getUserId();
  //   return set(child(astasquadreRef, asta_id + '/' + user_uid + '/plan/' + ruolo_abc + '/' + slot + '/crediti'), crediti);
  // }


  updatePlan(plan) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    // ma non devo eliminare gli eventuali associati e obiettivi
    let updates = {};
    for (const ruolo_abc in plan) {
      for (const slot in plan[ruolo_abc]) {
        for (const field in plan[ruolo_abc][slot]) {
          const value = plan[ruolo_abc][slot][field];
          updates['/' + ruolo_abc + '/' + slot + '/' + field] = value;
        }
      }
    }
    // console.log('updates', updates)
    return update(child(astasquadreRef, asta_id + '/' + user_uid + '/plan/'), updates);
  }

  setPlanAssociato(ruolo_abc, slot, calciatore_id) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    return set(child(astasquadreRef, asta_id + '/' + user_uid + '/plan/' + ruolo_abc + '/' + slot + '/associato'), calciatore_id);
  }

  setSettingsPlanAssociazione(method) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    return set(child(astasquadreRef, asta_id + '/' + user_uid + '/settings/plan/associazione'), method);
  }

  setSettingsPlanNRuoli(nPDCA, value) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    return set(child(astasquadreRef, asta_id + '/' + user_uid + '/settings/plan/nRuoli' + '/' + nPDCA), value);
  }

  scartaCalciatore(id_calciatore) {
    let asta_id = store.getters.asta_id;

    if (!id_calciatore) return Promise.reject("Error scartaCalciatore id_calciatore");

    // return astascartatiRef.child(asta_id).child(id_calciatore).set(1);
    return set(child(astascartatiRef, asta_id + '/' + id_calciatore), 1);
  }

  rimuoviCalciatoreScartato(id_calciatore) {
    let asta_id = store.getters.asta_id;

    if (!id_calciatore) return Promise.reject("Error rimuoviCalciatoreScartato id_calciatore");

    // return astascartatiRef.child(asta_id).child(id_calciatore).remove();
    return remove(child(astascartatiRef, asta_id + '/' + id_calciatore));
  }

  rimuoviScartati() {
    let asta_id = store.getters.asta_id;
    // return astascartatiRef.child(asta_id).remove();
    return remove(child(astascartatiRef, asta_id));
  }

  // round
  getAstaRound() {
    let asta_id = store.getters.asta_id;
    return get(child(astaroundRef, asta_id))
      .then((snapshot) => {
        let _round = snapshot.val();
        let round = this.initAstaRound(_round)
        return round
      });
  }

  initAstaRound(_round) {
    return {
      calciatoreInAsta: _round && _round.calciatoreInAsta ? _round.calciatoreInAsta : null,
      speaker: _round && _round.speaker ? _round.speaker : null,
      speakerTimeLeft: _round && _round.speakerTimeLeft ? _round.speakerTimeLeft : null,
      offerte: _round && _round.offerte ? _round.offerte : {},
      offerte_ts: _round && _round.offerte_ts ? _round.offerte_ts : {},
      chooser: _round && _round.chooser ? _round.chooser : null,
      step: _round && _round.step ? _round.step : null,
    }
  }

  fetchRound() {
    // let asta_id = store.getters.asta_id;
    // let astaref = child(astaroundRef, asta_id);

    // off(child(astaref, 'calciatoreInAsta'));
    // onValue(child(astaref, 'calciatoreInAsta'), (snapshot) => {

    let asta_id = store.getters.asta_id;
    let astaref = child(astaroundRef, asta_id);

    off(child(astaref, 'calciatoreInAsta'));
    onValue(child(astaref, 'calciatoreInAsta'), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ROUND_UPD, {
        calciatoreInAsta: _val
      })
      this.emit('calciatoreInAsta');
    });

    off(child(astaref, "speaker"));
    onValue(child(astaref, "speaker"), (snapshot) => {

      let _val = snapshot.val();
      store.commit(types.ROUND_UPD, {
        speaker: _val
      })
      this.emit("speaker");
    });

    off(child(astaref, "speakerTimeLeft"));
    onValue(child(astaref, "speakerTimeLeft"), (snapshot) => {

      let _val = snapshot.val();
      store.commit(types.ROUND_UPD, {
        speakerTimeLeft: _val
      })
      // this.emit("speakerTimeLeft");
    });

    off(child(astaref, 'chooser'));
    onValue(child(astaref, 'chooser'), (snapshot) => {

      let _val = snapshot.val() || null;
      store.commit(types.ROUND_UPD, {
        chooser: _val
      })
      // this.emit("chooser");
    });

    off(child(astaref, 'offerte'));
    onValue(child(astaref, 'offerte'), (snapshot) => {
      let _val = snapshot.val() || {};
      store.commit(types.ROUND_UPD, {
        offerte: _val
      })
      this.emit("offerte");
    });

    off(child(astaref, 'offerte_ts'));
    onValue(child(astaref, 'offerte_ts'), (snapshot) => {
      let _val = snapshot.val() || {};
      store.commit(types.ROUND_UPD, {
        offerte_ts: _val
      })
    });


    off(child(astaref, 'step'));
    onValue(child(astaref, 'step'), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ROUND_UPD, {
        step: _val
      })
    });
  }

  // fetchOnline(cb) {
  //   let _this = this;
  //   let asta_id = store.state.asta.info.id;

  //   astaonlineRef.child(asta_id).off();
  //   astaonlineRef.child(asta_id).on('value', function (snapshot) {

  //     // verifico esistenza mia squadra
  //     let _online = snapshot.val() || {};

  //     store.commit(types.ONLINE_SET, _online);

  // if (typeof cb === 'function')
  //   cb();

  //     _this.emit('online');
  //   });
  // }

  fetchOnline() {
    let asta_id = store.getters.asta_id;
    if (asta_id) {
      off(child(astaonlineRef, asta_id));
      onValue(child(astaonlineRef, asta_id), (snapshot) => {

        let _val = snapshot.val() || {};
        store.commit(types.ONLINE_SET, _val);
        this.emit('fetchedOnline');
      });
    }
  }



  initPresence() {
    let asta_id = store.getters.asta_id;
    let user_uid = store.state.user.user_uid;
    // let presenceRef = astaonlineRef.child(asta_id).child(user_uid);
    let presenceRef = child(astaonlineRef, asta_id + '/' + user_uid);
    return new Promise((resolve, reject) => {
      get(presenceRef)
        .then((snapshot) => {
          // se presence nn esiste o è reset...
          if (snapshot.val() === null || snapshot.val() === Constants.PRESENCE_STATES.RESET) {
            // ... allora mettiti in ascolto su connectedRef
            off(connectedRef);
            // connectedRef.on('value', (snap) => {
            //   if (snap.val() === true) {
            //     presenceRef.onDisconnect().remove().then(function () {
            //       // The promise returned from .onDisconnect().set() will
            //       // resolve as soon as the server acknowledges the onDisconnect() 
            //       // request, NOT once we've actually disconnected:
            //       // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

            //       // We can now safely set ourselves as 'online' knowing that the
            //       // server will mark us as offline once we lose connection.
            //       set(presenceRef, Constants.PRESENCE_STATES.ONLINE);
            //     });
            //   } else {
            //     set(presenceRef, Constants.PRESENCE_STATES.OFFLINE);
            //   }
            // });
            // // startIdle()
            onValue(connectedRef, (snap) => {
              // se true vuol dire che sono online
              if (snap.val() === true) {
                // ma prima di "set (presenceRef, ONLINE)"... 
                // ...dire al server come comportarsi in caso di disconnessione
                onDisconnect(presenceRef).remove()
                  .then(function() {
                    // The promise returned from .onDisconnect().remove() will
                    // resolve as soon as the server acknowledges the onDisconnect() 
                    // request, NOT once we've actually disconnected:
                    // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

                    // We can now safely set ourselves as 'online' knowing that the
                    // server will mark us as offline once we lose connection.
                    set(presenceRef, Constants.PRESENCE_STATES.ONLINE);
                  });
              } else {
                set(presenceRef, Constants.PRESENCE_STATES.OFFLINE);
              }
            });
            // startIdle()
            resolve()
          } else {
            // senno mostra pagina di reset
            reject(new ErrorSessionExist())
            // reject("Una tua sessione di Asta Live risulta già aperta in un'altra finestra. Puoi avere aperta solo una sessione alla volta.")
          }
        });
    })
  }

  initIdle() {
    let asta_id = store.getters.asta_id;
    let user_uid = store.state.user.user_uid;
    // let presenceRef = astaonlineRef.child(asta_id).child(user_uid);
    let presenceRef = child(astaonlineRef, asta_id + '/' + user_uid);
    return new idleJs({
      idle: 10000, // idle time in ms
      // events that will trigger the idle resetter
      events: ['mousemove', 'touchstart'],
      // callback function to be executed after idle time
      onIdle: () => {
        // set(presenceRef, Constants.PRESENCE_STATES.AWAY);
      },
      // callback function to be executed after back form idleness
      onActive: () => {
        set(presenceRef, Constants.PRESENCE_STATES.ONLINE);
      },
      onHide: () => {
        set(presenceRef, Constants.PRESENCE_STATES.AWAY)
        // this.emit("presenceOnHide")
      },
      onShow: () => {
        set(presenceRef, Constants.PRESENCE_STATES.ONLINE)
      },
      keepTracking: true, // set it to false of you want to track only once
      startAtIdle: false // set it to true if you want to start in the idle state
    })
  }

  resetPresence(asta_id) {
    let user_uid = authentication.getUserId();
    // let presenceRef = astaonlineRef.child(asta_id).child(user_uid);
    let presenceRef = child(astaonlineRef, asta_id + '/' + user_uid);
    return set(presenceRef, Constants.PRESENCE_STATES.RESET);
  }

  // ROUND
  // nextRound(chooser) {
  //   this.resetRound(chooser).then(() => {
  //     this.emit("nextRound")
  //   })
  // }

  updateSquadreActive(squadre, val) {
    let asta_id = store.getters.asta_id;
    let updates = {};
    if (_.size(squadre) > 0) {
      for (const squadra of Object.values(squadre)) {
        updates['/' + squadra.id + '/active'] = val;
      }
      return update(child(astasquadreRef, asta_id), updates);
    }
  }

  resetRound(chooser, stopAsta = false) {
    return this.setChooser(chooser) // è meglio che sia al primo posto così alla fine del round nn compare per un attimo al chooser di prima
      .then(this.setCalciatoreInAsta(null))
      .then(this.setStep(null))
      .then(this.setOfferte({}))
      .then(this.setSpeaker(null))
      .then(this.setSpeakerTimeLeft(null))
      // .then(() => {
      //   this.setChooser(chooser)
      // })
      .then(() => {
        if (stopAsta) {
          this.setSetting("status", Constants.ASTA_STATUS.NOT_RUNNING)
        }
      })
  }

  setCalciatoreInAsta(id_calciatore) {
    let asta_id = store.getters.asta_id;
    return set(child(astaroundRef, asta_id + '/calciatoreInAsta'), id_calciatore);
  }

  initRound(id_calciatore, asta_mode) {
    let user_uid = authentication.getUserId();
    let prossimoSpeaker = asta_mode == Constants.ASTA_MODE.POKER;
    let offerte = this.initOfferte(id_calciatore, asta_mode);
    let speaker = prossimoSpeaker ? this.prossimoSpeaker(user_uid, offerte) : null;
    return this.setOfferte(offerte)
      .then(this.setSpeaker(speaker))
  }

  // si controlla se si può acquistare (crediti, ruolo, club)
  // se nn si può acquistare metto PASSO
  // altrimenti INIT
  initOfferte(id_calciatore, asta_mode) {
    let user_uid = authentication.getUserId();
    let calciatore = store.getters.calciatori[id_calciatore];
    let chooser_mode = store.getters.asta_settings.ch_mode
    let regole_lega = store.state.asta.info.lega;
    let asta_squadre = store.getters.asta_squadre;
    let asta_squadre_attive = store.getters.asta_squadre_active;
    let base_asta = store.getters.asta_settings.base_asta
    let offerta_min = Helpers.minOfferta(base_asta, calciatore);
    let offerta_auto = store.getters.asta_settings.offerta_auto &&
      chooser_mode !== Constants.CHOOSER_MODE.ADMIN &&
      asta_mode != Constants.ASTA_MODE.BUSTA_CHIUSA;
    // se c'è offerta contestuale, devo fare il check di chi potrà offrire +1 rispetto alla minima
    let crediti_min = parseFloat(offerta_auto ? offerta_min + 1 : offerta_min);
    let _offerte = {};
    for (let sq of asta_squadre_attive) {
      let squadra = asta_squadre[sq.id];
      if (Helpers.canJoinRound(regole_lega, squadra, calciatore, crediti_min)) {
        _offerte[sq.id] = Constants.OFFERTA.INIT
      } else {
        _offerte[sq.id] = Constants.OFFERTA.PASSO
        // _offerte[sq.id] = Constants.OFFERTA.CREDITI_INSUFFICIENTI
      }
    }
    // sovrascivi la mia offerta (perchè si da per scontato che se l'ho scelto io, potevo sceglierlo)
    if (offerta_auto) {
      _offerte[user_uid] = offerta_min;
    }
    return _offerte;
  }

  // prossimoSpeaker (= true solo in Poker) -> calcola prossimo speaker 
  // noCheck (= true solo in BustaChiusa e Selvaggia)-> disattiva check su offerte altri giocatori
  // withTimestamp (PUO' essere true solo in BustaChiusa) ->
  setOfferta(off, prossimoSpeaker = true, noCheck = false, withTimestamp = false) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    let offerta = parseFloat(off);

    // offerte prima di quella appane fatta
    let offertePre = store.state.asta.round.offerte;
    // console.log("offertePre", offertePre)
    // offerte con quella appena fatta
    let offertePost = _.cloneDeep(offertePre);
    offertePost[user_uid] = offerta;

    // console.log("user_uid", user_uid)
    // console.log("offerta", offerta)
    // console.log("offertePost", offertePost)

    // se passo nn devo controllare le altre offerte (checkOfferte)
    // in BustaChiusa e Selvaggia nn devo controllare le altre offerte
    if (offerta === Constants.OFFERTA.PASSO || noCheck) {

      // SALVO TIMESTAMP OFFERTA SOLO SE DIVERSA DA PASSO (SERVE IN BUSTA CHIUSA)
      if (withTimestamp && offerta !== Constants.OFFERTA.PASSO) {
        // console.log("----------------- withTimestamp")
        // let speaker = prossimoSpeaker ? this.prossimoSpeaker(user_uid, offertePre) : null;
        let speaker = prossimoSpeaker ? this.prossimoSpeaker(user_uid, offertePost) : null;
        let updates = {};
        updates['/asta-round/' + asta_id + '/offerte/' + user_uid] = offerta;
        // updates['/asta-round/' + asta_id + '/offerte_ts/' + user_uid] = firebase.timestamp;
        updates['/asta-round/' + asta_id + '/offerte_ts/' + user_uid] = serverTimestamp();
        // return firebase.database.ref().update(updates, () => {
        // return update(ref(database), updates, () => {
        //   this.setSpeaker(speaker);
        // });
        return update(ref(database), updates)
          .then(() => {
            this.setSpeaker(speaker);
          });
      } else {
        let speaker = prossimoSpeaker ? this.prossimoSpeaker(user_uid, offertePost) : null;
        // return astaroundRef.child(asta_id).child('offerte').child(user_uid).set(offerta)
        //   .then(this.setSpeaker(speaker));
        return set(child(astaroundRef, asta_id + '/offerte/' + user_uid), offerta)
          .then(this.setSpeaker(speaker));
      }
    } else {
      // Se ho offerto
      // "offerte" verrà sovrascritto con PASSO se nn si può offrire +1 rispetto all'"offerta" attuale
      // let offertePostCheck = this.checkOfferte(offerta + 1, offertePre);
      let offertePostCheck = this.checkOfferte(user_uid, offerta, offertePost);
      // => in questo modo eviterò di dare lo speaker a chi nn potrà offrire +1
      let speaker = prossimoSpeaker ? this.prossimoSpeaker(user_uid, offertePostCheck) : null;
      // salvo tutte insieme
      // offertePostCheck[user_uid] = offerta;
      return this.setOfferte(offertePostCheck)
        .then(this.setSpeaker(speaker));
    }
  }

  // si controlla se si può acquistare (crediti)
  // se nn si può acquistare metto PASSO
  // altrimenti lascio quello che c'era
  checkOfferte(squadra_id, offerta_corrente, offerte) {
    let _offerte = _.cloneDeep(offerte);
    let asta_squadre = store.getters.asta_squadre;
    let asta_squadre_attive = store.getters.asta_squadre_active;
    for (let sq of asta_squadre_attive) {
      let squadra = asta_squadre[sq.id];
      // importante: devo saltare la squadra che ha fatto l'offerta
      if (squadra_id != sq.id && !Helpers.canRilanciare(squadra, parseFloat(offerta_corrente) + 1)) {
        _offerte[sq.id] = Constants.OFFERTA.PASSO
      }
    }
    // _offerte[squadra_id] = offerta_corrente;
    return _offerte;
  }

  // checkOfferte_OLD(offerta_corr, offerte) {
  //   let offerta_corrente = parseFloat(offerta_corr);
  //   let _offerte = _.cloneDeep(offerte);
  //   let asta_squadre = store.getters.asta_squadre;
  //   let asta_squadre_attive = store.getters.asta_squadre_active;

  //   for (let sq of asta_squadre_attive) {
  //     let squadra = asta_squadre[sq.id];
  //     let offerta = Helpers.calcoloOfferta(squadra, offerta_corrente);
  //     if (offerta !== null) {
  //       _offerte[sq.id] = offerta
  //     }
  //   }
  //   return _offerte;
  // }

  setPasso(user_uid, prossimoSpeaker) {
    let asta_id = store.getters.asta_id;
    let speaker = prossimoSpeaker ? this.prossimoSpeaker(user_uid, store.state.asta.round.offerte) : null;
    // return astaroundRef
    //   .child(asta_id)
    //   .child('offerte')
    //   .child(user_uid)
    //   .set(Constants.OFFERTA.PASSO)
    //   .then(this.setSpeaker(speaker));
    return set(child(astaroundRef, asta_id + '/offerte/' + user_uid), Constants.OFFERTA.PASSO)
      .then(this.setSpeaker(speaker));
  }

  setStep(step) {
    let asta_id = store.getters.asta_id;
    // return astaroundRef.child(asta_id).child('step').set(step);
    return set(child(astaroundRef, asta_id + '/step'), step);
  }

  setOfferte(offerte) {
    let asta_id = store.getters.asta_id;
    // return astaroundRef.child(asta_id).child('offerte').set(offerte);
    return set(child(astaroundRef, asta_id + '/offerte'), offerte);
  }

  setSpeaker(speaker) {
    let asta_id = store.getters.asta_id;
    // return astaroundRef.child(asta_id).child("speaker").set(speaker);
    return set(child(astaroundRef, asta_id + "/speaker"), speaker);
  }

  setSpeakerTimeLeft(timeLeft) {
    let asta_id = store.getters.asta_id;
    // return astaroundRef.child(asta_id).child('speakerTimeLeft').set(timeLeft);
    return set(child(astaroundRef, asta_id + '/speakerTimeLeft'), timeLeft);
  }

  setChooser(chooser) {
    let asta_id = store.getters.asta_id;
    // return astaroundRef.child(asta_id).child('chooser').set(chooser);
    return set(child(astaroundRef, asta_id + '/chooser'), chooser);
  }

  prossimoSpeaker(speakerCorrente, offerte) {
    // viene chiamato solo in astaPoker

    let squadre = store.getters.asta_squadre_active;

    let speakers = Utils.rotateArray(_.map(squadre, 'id'), speakerCorrente);

    let prossimo = null;

    _.each(speakers, (squadra_id) => {
      // se squadra_id ha fatto offerta e offerta != passo
      if (_.has(offerte, squadra_id)) {

        if (offerte[squadra_id] !== Constants.OFFERTA.PASSO) {
          prossimo = squadra_id;
          return false;
        }
      } else {
        prossimo = squadra_id;
        return false;
      }
    });
    // console.log("speakerCorrente", speakerCorrente)
    // console.log("offerte", offerte)
    let vincente = Helpers.vincenteUnicoAssegnabile(offerte);
    // console.log("vincente", vincente)

    // se prossimo prossimo == Vincente allora non ci sono altri speaker, quindi restituisci null
    if (prossimo && vincente && prossimo == vincente.squadra_id) {
      // console.log("prossimo = vincente => null")
      prossimo = null
    }
    // console.log("prossimo", prossimo)
    // console.log('--------------')
    return prossimo;
  }

  prossimoStep(offertaVincente) {
    let offerte = _.cloneDeep(store.state.asta.round.offerte);
    var offerte_vincenti = _.sumBy(_.values(offerte), i => (i === offertaVincente ? 1 : 0));

    for (let sqid in offerte) {
      if (offerte[sqid] === offertaVincente) {
        if (offerte_vincenti > 1) {
          offerte[sqid] = Constants.OFFERTA.INIT;
        }
      } else {
        offerte[sqid] = Constants.OFFERTA.PASSO;
      }
    }

    if (offerte_vincenti > 1) {
      return this.setStep({
        type: Constants.ROUND_STEP.OFFERTE,
        min_offerta: offertaVincente
      }).then(this.setOfferte(offerte));
    } else {
      return this.setOfferte(offerte)
    }
  }

  addMessage(msg, cb) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    const newRef = push(child(astamessagesRef, asta_id));
    set(newRef, {
      id: user_uid,
      text: msg,
      type: Constants.MESSAGE_TYPE.CHAT,
      ts: serverTimestamp(),
    }).then(cb())

    // child(astamessagesRef, asta_id).push({
    //   id: user_uid,
    //   text: msg,
    //   type: Constants.MESSAGE_TYPE.CHAT,
    //   ts: {
    //     '.sv': 'timestamp'
    //   }
    // }, cb);
  }

  fetchMessages() {

    let asta_id = store.getters.asta_id;
    if (asta_id) {
      var newItems = false;

      off(child(astamessagesRef, asta_id));
      //    astamessagesRef.child(asta_id).orderByChild("type").equalTo(Constants.MESSAGE_TYPE.CHAT).limitToLast(20).on('child_added', function (snapshot) {
      const queryRef = query(child(astamessagesRef, asta_id), limitToLast(20));
      onChildAdded(queryRef, (snapshot) => {
        if (!newItems) return;
        var message = snapshot.val();
        store.commit(types.MESSAGES_ADD, message);
        this.emit('newMessage', message);
      });
      //    astamessagesRef.child(asta_id).orderByChild("type").equalTo(Constants.MESSAGE_TYPE.CHAT).limitToLast(20).once('value', function (snapshot) {
      // get(limitToLast(child(astamessagesRef, asta_id), 20), (snapshot) => {
      //   newItems = true;
      //   var messages = snapshot.val();
      //   store.commit(types.MESSAGES_SET, _.values(messages));
      // });
      get(queryRef)
        .then((snapshot) => {
          newItems = true;
          var messages = snapshot.val();
          store.commit(types.MESSAGES_SET, _.values(messages));
        })
    }

  }


  fetchScartati(cb) {

    let asta_id = store.getters.asta_id;
    if (asta_id) {
      off(child(astascartatiRef, asta_id));
      onValue(child(astascartatiRef, asta_id), function(snapshot) {

        // verifico esistenza mia squadra
        let _scartati = snapshot.val() || {};

        store.commit(types.SCARTATI_SET, _scartati);

        if (typeof cb === 'function')
          cb();
      });
    }

  }

  setSetting(key, value) {
    let asta_id = store.getters.asta_id;
    return set(child(astaRef, asta_id + '/settings/' + key), value);
  }

  setSettings(settings) {
    let asta_id = store.getters.asta_id;
    // console.log('settings', settings)
    // console.log('asta_id', asta_id)
    return update(child(astaRef, asta_id + '/settings'), settings);
  }

  setLegaSettings(legaSettings) {
    let asta_id = store.getters.asta_id;
    // console.log('legaSettings', legaSettings)
    // console.log('asta_id', asta_id)
    return update(child(astaRef, asta_id + '/lega'), legaSettings);
  }

  updateCounter() {
    let asta_id = store.getters.asta_id;

    return new Promise(function(resolve, reject) {
      if (store.state.asta.info.premium)
        return resolve();

      // astaRef.child(asta_id).child('counter').transaction(function (curr) {
      // child(astaRef, asta_id + '/counter').transaction(function (curr) {
      //   return (curr || 0) - 1;
      // }, function (err, success, snap) {
      //   // if the counter updates successfully, then write the record
      //   if (err)
      //     return reject();

      //   if (success) {
      //     if (snap.val() == 0)
      //       return reject();
      //     return resolve();
      //   }
      // })

      // Run a transaction
      runTransaction(child(astaRef, asta_id + '/counter'), (currentData) => {
        // Modify the current data
        if (currentData === null) {
          // Handle the case when the data doesn't exist
          return 1; // Set the new data value
        } else {
          // Handle the case when the data exists
          // Modify the current data and return the modified value
          const newData = currentData - 1;
          return newData; // Set the modified data value
        }
      }).then((transactionResult) => {
        // Handle the transaction result
        return resolve();
      }).catch((error) => {
        // Handle any errors that occurred during the transaction
        console.error('Transaction failed:', error);
        return reject();
      });

    });
  }

  // setAstaMsg(type, msg) {
  //   let asta_id = store.getters.asta_id;
  //   return astaRef.child(asta_id).child('msg').set({
  //     type: type,
  //     text: msg
  //   });
  // }

  // setLastAstaLog(log) {
  //   let asta_id = store.getters.asta_id;
  //   return astaLogsRef.child(asta_id).child('last').set({
  //     ...log,
  //   });
  // }

  // pushAstaLog_OLD(log) {
  //   return new Promise((resolve, reject) => {
  //     let asta_id = store.getters.asta_id;
  //     return child(astaLogsRef, asta_id).push({
  //       ...log,
  //       // ts: firebase.timestamp,
  //       ts: timestamp,
  //     }, resolve());
  //   })
  // }

  pushAstaLog(log) {
    let asta_id = store.getters.asta_id;
    const newRef = push(child(astaLogsRef, asta_id));
    return set(newRef, {
      ...log,
      // ts: firebase.timestamp,
      ts: serverTimestamp(),
    })
  }

  addAstaToUser(anno_id, uid, torneo_id, asta_id) {
    return set(child(userAstaRef, anno_id + '/' + uid + '/' + torneo_id + '/' + asta_id), 1);
  }

  addToAstaBasic(torneo_id, anno_id, asta_id, astaBasic) {
    return set(child(astaBasicRef, torneo_id + '/' + anno_id + '/' + asta_id), astaBasic);
  }

  // getAsteBasic() {
  //   return get(child(astaBasicRef, Config.TORNEO_ID + '/' + Config.ANNO_ID))
  //     .then((snapshot) => {
  //       let output = []
  //       // se nn lo trasformo in array, rischio che vue mi perde l'ordinamento giusto
  //       snapshot.forEach((childSnapshot) => {
  //         let astaBasic = childSnapshot.val();
  //         //astaBasic.asta_id = childSnapshot.key // aggiungo la key tra i valori per facilitarmi dopo
  //         output.unshift(astaBasic) // perchè firebase nn me lo da direttamente in ordine inverso
  //       });
  //       return output
  //     });
  // }

  // getAstaBasic(asta_id) {
  //   return get(child(astaBasicRef, Config.TORNEO_ID + '/' + Config.ANNO_ID + '/' + asta_id))
  //     .then((snapshot) => {
  //       return snapshot.val()
  //     });
  // }

  getUserAsteId(uid) {
    return get(child(userAstaRef, Config.ANNO_ID + '/' + uid + '/' + Config.TORNEO_ID))
      .then((snapshot) => {
        let output = []
        // se nn lo trasformo in array, rischio che vue mi perde l'ordinamento giusto
        snapshot.forEach((childSnapshot) => {
          output.unshift(childSnapshot.key) // perchè firebase nn me lo da direttamente in ordine inverso
        });
        return output
      });
  }
}

export default new Asta()